const actions = {
  CREATE_MEMBER_CARD: 'CREATE_MEMBER_CARD',
  CREATE_MEMBER_CARD_ENDED: 'CREATE_MEMBER_CARD_ENDED',
  CREATE_ISSUED_MEMBER_CARD: 'CREATE_ISSUED_MEMBER_CARD',
  CREATE_ISSUED_MEMBER_CARD_ENDED: 'CREATE_ISSUED_MEMBER_CARD_ENDED',
  SEARCH_MEMBER_CARDS: 'SEARCH_MEMBER_CARDS',
  SEARCH_MEMBER_CARDS_ENDED: 'SEARCH_MEMBER_CARDS_ENDED',
  SEARCH_ISSUED_MEMBER_CARD_BATCHES: 'SEARCH_ISSUED_MEMBER_CARD_BATCHES',
  SEARCH_ISSUED_MEMBER_CARD_BATCHES_ENDED: 'SEARCH_ISSUED_MEMBER_CARD_BATCHES_ENDED',
  SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS: 'SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS',
  SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS_ENDED: 'SEARCH_ISSUED_MEMBER_CARD_BATCH_ROWS_ENDED',
  SEARCH_MEMBER_CARD_TRANSACTION_RECORDS: 'SEARCH_MEMBER_CARD_TRANSACTION_RECORDS',
  SEARCH_MEMBER_CARD_TRANSACTION_RECORDS_ENDED: 'SEARCH_MEMBER_CARD_TRANSACTION_RECORDS_ENDED',
  FIND_MEMBER_CARD: 'FIND_MEMBER_CARD',
  FIND_MEMBER_CARD_ENDED: 'FIND_MEMBER_CARD_ENDED',
  UPDATE_MEMBER_CARD: 'UPDATE_MEMBER_CARD',
  UPDATE_MEMBER_CARD_ENDED: 'UPDATE_MEMBER_CARD_ENDED',
  UPDATE_ISSUED_MEMBER_CARD_BATCH: 'UPDATE_ISSUED_MEMBER_CARD_BATCH',
  UPDATE_ISSUED_MEMBER_CARD_BATCH_ENDED: 'UPDATE_ISSUED_MEMBER_CARD_BATCH_ENDED',
  UPDATE_ISSUED_MEMBER_CARDS: 'UPDATE_ISSUED_MEMBER_CARDS',
  UPDATE_ISSUED_MEMBER_CARDS_ENDED: 'UPDATE_ISSUED_MEMBER_CARDS_ENDED',
  DELETE_MEMBER_CARDS: 'DELETE_MEMBER_CARDS',
  DELETE_MEMBER_CARDS_ENDED: 'DELETE_MEMBER_CARDS_ENDED',
  GET_MEMBER_CARDS_STATISTICS: 'GET_MEMBER_CARDS_STATISTICS',
  GET_MEMBER_CARDS_STATISTICS_ENDED: 'GET_MEMBER_CARDS_STATISTICS_ENDED',
};

export default actions;
